import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import AwesomeLoaders from "bsm-loaders";
import VueI18n from "vue-i18n";
import i18n from "../src/translate";
import "animate.css";
import PrimeVue from "../primevue/config";
import Card from "../primevue/card";
import Rating from '../primevue/rating';
import Timeline from '../primevue/timeline';
import ConfirmationService from "../primevue/confirmationservice";
import AccordionTab from "../primevue/accordiontab";
import Accordion from "../primevue/accordion";
import Message from "../primevue/message";
// import 'primevue/resources/themes/saga-blue/theme.css';
import Password from "../primevue/password";
import Inplace from '../primevue/inplace';

// import 'primevue/resources/themes/bootstrap4-dark-blue/theme.css';
import "../primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import ProgressBar from "../primevue/progressbar";
import Skeleton from "../primevue/skeleton";
import Editor from "../primevue/editor";
import Carousel from '../primevue/carousel';
import ScrollPanel from "../primevue/scrollpanel";
import ScrollTop from "../primevue/scrolltop";
import ProgressSpinner from "../primevue/progressspinner";
import Divider from "../primevue/divider";
import ToggleButton from "../primevue/togglebutton";
import Tooltip from "../primevue/tooltip";
import InputNumber from "../primevue/inputnumber";
import Checkbox from "../primevue/checkbox";
import InputText from "../primevue/inputtext";
import Button from "../primevue/button";
import Toast from "../primevue/toast";
import Chart from '../primevue/chart';
import ColorPicker from "../primevue/colorpicker";
import DataTable from "../primevue/datatable";
import DataTableOriginal from "primevue/datatable";
import ColumnOriginal from "primevue/column";
import Column from "../primevue/column";
import BlockUI from '../primevue/blockui';
import Badge from "../primevue/badge";
import BadgeDirective from "../primevue/badgedirective";
import TabView from '../primevue/tabview';
import TabPanel from '../primevue/tabpanel';
import TabMenu from '../primevue/tabmenu';
import AutoComplete from '../primevue/autocomplete';
import SelectButton from '../primevue/selectbutton';
import FileUpload from '../primevue/fileupload';
import Storage from 'vue-ls';

const options = {
  namespace: 'mySchool_', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
};

Vue.use(Storage, options);
// import ToastService from 'primevue/toastservice';
import Slider from "../primevue/slider";
import SliderOriginal from "primevue/slider";
import Panel from "../primevue/panel";
import Dropdown from "../primevue/dropdown";
import Dialog from "../primevue/dialog";
import MultiSelect from "../primevue/multiselect";
import Menu from "../primevue/menu";
import Knob from "../primevue/knob";
// const app = createApp(App);
import { vsButton, vsSelect, vsPopup } from "vuesax";
import Vuesax from "vuesax";
import axios from "axios";
import TriStateCheckbox from "../primevue/tristatecheckbox";
import Calendar from "../primevue/calendar";

import Textarea from "../primevue/textarea";
const baseUrl = process.env.VUE_APP_API_ENDPOINT
console.log("baseUrl", baseUrl)
axios.defaults.baseURL = baseUrl;
Vue.use(axios);
Vue.use(ConfirmationService);

import "vuesax/dist/vuesax.css"; //Vuesax styles
Vue.use(Vuesax, {
  // options here
});
import "vuesax/dist/vuesax.css";
import SpeedDial from '../primevue/speeddial';
// Vue.use(vsButton)
// Vue.use(vsSelect)
// Vue.use(vsPopup)
import OverlayPanel from "../primevue/overlaypanel";
Vue.use(PrimeVue);
Vue.directive("Tooltip", Tooltip);

import VueSimplePrintPlugin from 'vue-simple-print';

Vue.use(VueSimplePrintPlugin);

Vue.component("FileUpload", FileUpload);
Vue.component("Rating", Rating);
Vue.component("Message", Message);
Vue.component("Timeline", Timeline);
Vue.component("Carousel", Carousel);
Vue.component("SpeedDial", SpeedDial);
Vue.component("Card", Card);
Vue.component("TabMenu", TabMenu);
Vue.component("Inplace", Inplace);
Vue.component("Accordion", Accordion);
Vue.component("AccordionTab", AccordionTab);
Vue.component("Chart", Chart);
Vue.component("AutoComplete", AutoComplete);
// Vue.component("TextareaHtml", TextareaHtml);
Vue.component("Editor", Editor);
Vue.component("SelectButton", SelectButton);
// app.directive('badge', BadgeDirective);

Vue.directive("badge", BadgeDirective);
Vue.component("TabPanel", TabPanel);
Vue.component("TabPanel", TabPanel);
Vue.component("TabView", TabView);
Vue.component("Badge", Badge);
Vue.component("Divider", Divider);
Vue.component("BlockUI", BlockUI);
Vue.component("TriStateCheckbox", TriStateCheckbox);
Vue.component("Password", Password);
Vue.component("ScrollPanel", ScrollPanel);
Vue.component("ScrollTop", ScrollTop);
Vue.component("ProgressSpinner", ProgressSpinner);
Vue.component("ToggleButton", ToggleButton);

Vue.component("Textarea", Textarea);

Vue.component("Calendar", Calendar);
Vue.component("Knob", Knob);
Vue.component("Skeleton", Skeleton);

Vue.component("Toast", Toast);

Vue.component("ProgressBar", ProgressBar);
Vue.component("OverlayPanel", OverlayPanel);
Vue.component("Dialog", Dialog);
Vue.component("Checkbox", Checkbox);

Vue.component("InputNumber", InputNumber);

Vue.component("Menu", Menu);

Vue.component("MultiSelect", MultiSelect);

Vue.component("DataTable", DataTable);
Vue.component("DataTableOriginal", DataTableOriginal);
Vue.component("Dialog", Dialog);

Vue.component("Panel", Panel);
Vue.component("ColorPicker", ColorPicker);
Vue.component("Column", Column);
Vue.component("ColumnOriginal", ColumnOriginal);

Vue.component("Slider", Slider);
Vue.component("SliderOriginal", SliderOriginal);
Vue.component("Dropdown", Dropdown);
Vue.component("Button", Button);
Vue.component("InputText", InputText);

// Vue.use(PrimeVue);
Vue.use(VueI18n);

Vue.config.productionTip = false;

// delete Icon.Default.prototype._getIconUrl;

router.beforeEach((to, from, next) => {
  if (to.name !== "Login" && !localStorage.getItem("authorization"))
    next({ name: "Login" });
  else next();
});

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

Vue.use(AwesomeLoaders);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
